import type { GroupTransformer } from "@/types/workspace";
import { Text } from "@mantine/core";
import { TransformerBase } from "./TransformerBase";

export function TransformerGroup({
  data: _data,
  warning,
  error,
  onUpdate: _onUpdate,
}: {
  data: GroupTransformer;
  warning?: string;
  error?: string;
  onUpdate?: (updatedData: GroupTransformer) => void;
}) {
  return (
    <TransformerBase warning={warning} error={error}>
      <Text fz={14} lh={1.4} fw={500} c="gray.9">
        Not implemented
      </Text>
    </TransformerBase>
  );
}
